import React, { forwardRef } from "react";

import Header from "../Header";
import Submit from "../HandleSubmit";
import { formatMatches } from "../../../utils/format-matches";
import { periodTimer } from "../../../utils/period-timer";

// Ending the last period on a draw ended that period and started the shootout
// in one go (`EndMatch.js`). Deleting the shootout undoes both: the last period
// is running again
const deleteShootout = ({
    shootoutStart,
    matchData,
    matchId,
    setMatchData,
    sides,
    homePlayers,
    awayPlayers,
    setEventsToShow,
    setGoals,
    setTimersPerQuarter,
    formatApiData,
}) => {
    const [numberOfPeriods, minutes] = formatMatches(matchData.formatObject);
    // End-of-period posts are 2, 4, 6 and 8 for periods 1 to 4
    const lastPeriodEnd = numberOfPeriods * 2;
    const lastPeriod = `Q${numberOfPeriods}`;

    const update = {
        matchPosts: matchData.matchPosts.map((post) => {
            if (
                post.id === shootoutStart.id ||
                post.postType === lastPeriodEnd ||
                post.type === "Penalty Shootout"
            ) {
                return {
                    ...post,
                    isDeleted: true,
                };
            }
            return post;
        }),
        quarter1: numberOfPeriods > 1,
        quarter2: numberOfPeriods > 2,
        quarter3: numberOfPeriods > 3,
        quarter4: false,
        shootout: false,
    };

    Submit(matchId, matchData, update, setMatchData)
        .then((data) => {
            if (!data) {
                return;
            }

            formatApiData(
                data,
                sides,
                setEventsToShow,
                ...homePlayers,
                ...awayPlayers,
            );
            // The shootout goals were counted in, as on adding them
            setGoals({
                home: data.homeGoals,
                away: data.awayGoals,
            });
            // Ending the period marked it ended, and nothing marks it running
            // again; the timer stood where it was when the shootout started
            const dhbTimer = data.dhbMatchTimers;
            setTimersPerQuarter((details) => ({
                ...details,
                [lastPeriod]: {
                    ...details[lastPeriod],
                    quarterEnded: false,
                    ...(dhbTimer && `Q${dhbTimer.quarter}` === lastPeriod
                        ? periodTimer(dhbTimer, minutes * 60)
                        : {}),
                },
            }));
        })
        .catch((e) => console.error(e.message));
};

// The start of a shootout can only be deleted: there is nothing to edit on it.
const EditShootoutEvent = forwardRef(
    (
        {
            setIsEditModalOpen,
            eventDetailsToEdit,
            setEventDetailsToEdit,
            isEditing,
            matchData,
            matchId,
            setMatchData,
            sides,
            homePlayers,
            awayPlayers,
            setEventsToShow,
            setGoals,
            setTimersPerQuarter,
            formatApiData,
        },
        ref,
    ) => {
        return (
            <div
                ref={ref}
                style={{
                    backgroundColor: "#E5E5E5",
                }}
            >
                <Header
                    eventDetails={eventDetailsToEdit}
                    setEventDetails={setEventDetailsToEdit}
                    setModalOpen={setIsEditModalOpen}
                    isEditing={isEditing}
                    matchData={matchData}
                    matchId={matchId}
                    setMatchData={setMatchData}
                    onDelete={() =>
                        deleteShootout({
                            shootoutStart: eventDetailsToEdit,
                            matchData,
                            matchId,
                            setMatchData,
                            sides,
                            homePlayers,
                            awayPlayers,
                            setEventsToShow,
                            setGoals,
                            setTimersPerQuarter,
                            formatApiData,
                        })
                    }
                />
            </div>
        );
    },
);

export default EditShootoutEvent;
